import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Common/Breadcrumb';

const BusinessSupport = () => {
  const services = [
    {
      id: 1,
      title: "Accounting & Bookkeeping",
      description: "• Payroll Processing\n• Tax Filing\n• Financial Reporting",
      icon: "fas fa-calculator"
    },
    {
      id: 2,
      title: "Business Expansion Consulting",
      description: "• Franchise Research\n• Funding Assistance\n• Market Entry Strategy",
      icon: "fas fa-chart-bar"
    },
    {
      id: 3,
      title: "Recruitment & Staffing",
      description: "• Hiring Support\n• LMIA for New Employees\n• HR Consultation",
      icon: "fas fa-users"
    },
    {
      id: 4,
      title: "Digital Tools Integration",
      description: "• POS System Setup\n• CRM & Inventory Tools\n• Automation Solutions",
      icon: "fas fa-tools"
    },
    {
      id: 5,
      title: "Marketing Strategy Support",
      description: "• Social Media Marketing\n• Campaign Management\n• Branding and Rebranding",
      icon: "fas fa-bullhorn"
    }
  ];

  return (
    <>
      <Breadcrumb title="Business Support" />

      <div className="container-fluid service overflow-hidden pt-5">
        <div className="container py-5">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="sub-style">
              <h5 className="sub-title text-primary px-3">Business Support Services</h5>
            </div>
            <h1 className="display-5 mb-4">Support solutions tailored to help existing businesses grow, scale, and operate efficiently in Canada</h1>
            <p className="mb-0">From accounting and bookkeeping to business expansion consulting, recruitment support, digital tools integration, and marketing strategy—we provide comprehensive solutions to help your business thrive. Our expertise covers all aspects of business operations and growth.</p>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div id="services" className="container-fluid">
        <div className="container py-5">
          <div className="row g-4">
            {services.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${service.id * 0.1}s`}>
                <div className="service-card h-100 bg-white rounded shadow-sm p-4 border-0 hover-lift">
                  <div className="text-center mb-4">
                    <div className="service-icon bg-primary rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                      <i className={`${service.icon} fa-2x text-white`}></i>
                    </div>
                  </div>
                  <h4 className="text-primary mb-3 text-center">{service.title}</h4>
                  <p className="text-muted text-center mb-0" style={{ whiteSpace: 'pre-line' }}>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact CTA Section */}
      <div className="container-fluid bg-light">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center wow fadeInUp" data-wow-delay="0.1s">
              <h2 className="text-primary mb-4">Ready to take your business to the next level?</h2>
              <p className="text-muted fs-5 mb-4">Let us help you grow and succeed in Canada.</p>
              <Link to="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Get Support</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessSupport; 